module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-category-list__single qa-category"
  }, [_c('div', {
    staticClass: "c-category-list__single__thumb"
  }, [_c('img', {
    staticClass: "o-media c-category-list__single__thumb__img",
    attrs: {
      "src": _vm.thumb
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "c-category-list__single__title t-category-headline"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('img', {
    staticClass: "c-category-list__single__spacer",
    attrs: {
      "src": "/img/thm350.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c82f819"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/CategoryListTile.vue
// module id = 555
// module chunks = 1